export const BAD_SLIP_SCAN_ERROR_MSG = {
  30007: 'รหัสอ้างอิงนี้ถูกใช้ไปแล้ว กรุณาสแกนข้อมูลใหม่',
  30017: 'ไม่สามารถอ่านสลิปได้ในขณะนี้ กรุณาลองใหม่',
  30021: 'ระบบไม่รองรับรูปแบบ QR code ประเภทนี้',
  30065: 'รหัสอ้างอิงไม่ถูกต้อง กรุณาสแกนข้อมูลใหม่',
}

export const SLIP_APPROVE_ERROR_MSG = {
  30060: 'ข้อมูลรหัสอ้างอิง หรือ จำนวนเงินไม่ถูกต้อง ไม่สามารถ approve สลิปได้',
  30010: 'หมายเลขอ้างอิงนี้ถูกใช้ไปแล้ว ไม่สามารถ approve สลิปได้',
}

export const SLIP_RECHECK_ERROR_MSG = {
  30007: 'รหัสอ้างอิงนี้ถูกใช้ไปแล้ว กรุณาสแกนข้อมูลใหม่',
  30017: 'ไม่สามารถอ่านสลิปได้ในขณะนี้ กรุณาลองใหม่',
  30021: 'ระบบไม่รองรับรูปแบบ QR code ประเภทนี้',
  30065: 'รหัสอ้างอิงไม่ถูกต้อง กรุณาสแกนข้อมูลใหม่',
}

export const DEFAULT_ERROR_MSG = 'ระบบเกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง'
